<div class="flex justify-center items-center" *ngIf="loading">
    <mat-spinner
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
    >
    </mat-spinner>
</div>

<div class="grid grid-cols-1 gap-y-2" *ngIf="!loading">
    <h3 class="text-center md:text-left mb-2"><b>Please enter your Mobicred login details</b></h3>
    <form [formGroup]="loginForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-x-4">
            <mat-form-field class="tile" appearance="none">
                <mat-label><strong>Username</strong></mat-label>
                <input
                    (click)="resetValidation()"
                    matInput
                    placeholder="email@example.com"
                    formControlName="username"
                    required
                    [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                    Please enter {{(usernameControl.value.name ? usernameControl.value.name : 'a valid email')| lowercase}}.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="tile" appearance="none">
                <mat-label><strong>Password</strong></mat-label>
                <input
                    (click)="resetValidation()"
                    matInput
                    [type]="hide ? 'password' : 'text'"
                    required
                    formControlName="password"
                    [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                    Please enter {{(passwordControl.value.name ? passwordControl.value.name : 'a valid password')| lowercase}}.
                </mat-error>
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </form>
    <p *ngIf="!login" class="text-center md:text-left">Don't have a Mobicred account? <a href="{{mobicredUrl}}" target="_top">Apply here</a></p>
    <button class="pay py-3 mt-4 w-full min-w-max md:px-12 text-lg font-semibold tracking-widest continue justify-self-center md:justify-self-end" [ngStyle]="{'background-color':getColorScheme(), 'color':getTextColor()}" mat-raised-button (click)="formValidation()">Pay Now</button>
</div>
